import { Avatar, Stack, Typography } from '@mui/material';

import useFormat from '../../../hooks/useFormat';

type SupportItemProps = {
	action: JSX.Element;
	content: JSX.Element;
};

const SupportItem = ({ action, content }: SupportItemProps) => {
	const { isMobileFormat } = useFormat();

	return (
		<Stack flexDirection="row" gap={2}>
			{!isMobileFormat && <Avatar src="/logoCollapsed" />}
			<Stack width="100%">
				{!isMobileFormat && <Typography variant="subtitle2">Équipe Support</Typography>}
				{content}
				{action}
			</Stack>
		</Stack>
	);
};

export default SupportItem;
